module.exports = __webpack_public_path__ + "img/docUploadIcon.227011dd.svg";